import httpRequest from '../../utils/request';

// Generar factura desde venta
const generateInvoiceFromSale = async (data) => {
  const response = await httpRequest.post('/invoices/generate', data);
  return response.data;
};

// Generar factura manual
const generateManualInvoice = async (data) => {
  const response = await httpRequest.post('/invoices/manual', data);
  return response.data;
};

// Obtener todas las facturas
const getInvoices = async () => {
  const response = await httpRequest.get('/invoices');
  return response.data;
};

// Obtener factura por ID
const getInvoiceById = async (id) => {
  const response = await httpRequest.get(`/invoices/${id}`);
  return response.data;
};

// Anular factura
const anularInvoice = async (id) => {
  const response = await httpRequest.put(`/invoices/${id}/anular`);
  return response.data;
};

// Obtener tipos de comprobante
const getTiposComprobante = async () => {
  const response = await httpRequest.get('/invoices/tipos-comprobante');
  return response.data;
};

// Obtener condiciones de IVA
const getCondicionesIVA = async () => {
  const response = await httpRequest.get('/invoices/condiciones-iva');
  return response.data;
};

// Reporte IVA ventas (JSON)
const getIvaSalesReport = async ({ from, to }) => {
  // Request full rows (include internal id) so UI can perform actions like PDF download
  const response = await httpRequest.get('/invoices/iva-sales', {
    params: { from, to, format: 'json' },
  });
  return response.data; // { range, count, rows, totals }
};

// Descargar reporte IVA ventas en XLSX
const downloadIvaSalesReport = async ({ from, to }) => {
  const response = await httpRequest.get('/invoices/iva-sales', {
    params: { from, to, format: 'xlsx' },
    responseType: 'blob',
  });
  return response; // blob en response.data
};

// Descargar PDF de factura por id
const downloadInvoicePdf = async (id) => {
  const response = await httpRequest.get(`/invoices/${id}/pdf`, {
    responseType: 'blob',
  });
  return response;
};

const invoiceService = {
  generateInvoiceFromSale,
  generateManualInvoice,
  getInvoices,
  getInvoiceById,
  anularInvoice,
  getTiposComprobante,
  getCondicionesIVA
};

// Extender export con funciones de reporte IVA
invoiceService.getIvaSalesReport = getIvaSalesReport;
invoiceService.downloadIvaSalesReport = downloadIvaSalesReport;
invoiceService.downloadInvoicePdf = downloadInvoicePdf;

export default invoiceService;
